import angular from 'angular';

import User from './user/';
import Financing from './financing/';
import Licenses from './licenses/';
import Offices from './offices/';

import AccountsController from './accountsController';
import AccountsService from './accountsFactory';

export default angular.module('app.accounts', [
    // features
    User,
    Financing,
    Licenses,
    Offices,
])
    .controller('AccountsController', AccountsController)
    .service('AccountsFactory', AccountsService)
    .run(($templateCache) => {
        $templateCache.put('app/accounts/user/myprofile.html', require('./user/myprofile.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/user/paceCredential/paceCredential.html', require('./user/paceCredential/paceCredential.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/user/users.html', require('./user/users.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/offices.html', require('./offices/offices.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/financing/financing.html', require('./financing/financing.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/licenses/licenses.html', require('./licenses/licenses.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/accounts/index.js